import React, { Component } from 'react';
import { Container, Row, Col, FormCheck, FormLabel, Form } from 'react-bootstrap';
//libs
import {
  PeripheralLicenseDomain,
  PeripheralLicenseDomains,
} from '../lib/domain';

class DomainList extends Component {
  constructor(props) {
    super(props);
    this.DomainChecked = this.DomainChecked.bind(this); //Inherited from parent
    this.ToggleAllDomains = this.ToggleAllDomains.bind(this);
    this.state = {
      AddedDomains: new Array(), //Saves the currently selected checkboxs items
      chkToggleAllDomains: false,
      Domains: this.props.domains.map(domain => {
        domain.isChecked = false;
        return domain;
      }),
    };
  }

  //Handles checking/unchecking of a domain from the list. Will add/remove it from state array of selected items.
  async DomainChecked({ target }) {
    let _domains = this.state.Domains.map(domain => {
      if (domain.Name === target.value) {
        domain.isChecked = target.checked ? true : false;
      }
      return domain;
    });

    //Pass the selected domains into the parent app
    this.setState({
      Domains: _domains,
    });
    this.props.onSelectedDomainsChanged(
      this.state.Domains.filter(domain => {
        return domain.isChecked === true;
      })
    );
  }

  static getDerivedStateFromProps(props, state) {
    props.domains.map(domain => {
      let _existing = state.Domains.find(x => x.Id === domain.Id);
      if (_existing && _existing.Id === domain.Id) {
      } else {
        state.Domains = [...state.Domains, domain];
      }
    });

    return state;
  }

  ToggleAllDomains({ target }) {
    let _domains = this.state.Domains;
    _domains.map(domain => {
      domain.isChecked = target.checked ? true : false;
      return domain;
    });
    this.setState({ Domains: _domains });
    this.props.onSelectedDomainsChanged(
      this.state.Domains.filter(domain => {
        return domain.isChecked === true;
      })
    );
  }
  render() {
    return (
      <Container>
        <Row className="distkey-domains-selectall">
          {!this.props.selectAllDisabled &&
            <Col md={12}>
              <Form inline className={`pt-4 pb-4`}>
                <FormCheck
                  type="checkbox"
                  value={this.state.chkToggleAllDomains}
                  name={`chkToggleAllDomains`}
                  id={`chkToggleAllDomains`}
                  onChange={this.ToggleAllDomains}
                />
                <FormLabel htmlFor={`chkToggleAllDomains`}><b>Select All Hostnames</b></FormLabel>
              </Form>
            </Col>
          }

        </Row>
        <Row>
          <Col md={12} className="distkey-domains-domains">
            {this.state.Domains ? (
              this.state.Domains.map((domain, index) => {
                return (
                  <div key={index}>
                    <FormCheck
                      type="checkbox"
                      value={domain.Name}
                      name={`chklist-domains[${domain.Name}]`}
                      id={`chklist-domains[${domain.Name}]`}
                      checked={domain.isChecked}
                      onChange={this.DomainChecked}
                      disabled={this.props.disabled && (!domain.isChecked || false)}
                      label={domain.Name}
                    />
                  </div>
                );
              })
            ) : (
                <p>loading...</p>
              )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DomainList;
